export default {
    REGULAR: "regular",
    GROUP: "group"
};
